import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'pesagens/finalizar_pesagem';

async function readBarCode(code) {
    try {
        var data = await ServiceBase.postData(`${endpoint}`,code);
        return data;
    } catch (e) {
        throw e;
    }
}

export const CodeService = {
    readBarCode
}